module Meevo.Plugins.Memberships {
    import Membership = Meevo.Model.Membership;
    import MemberTypeEnum = Meevo.Model.MemberTypeEnum;
    import IMembershipMemberSettings = Meevo.Model.IMembershipMemberSettings;
    import FeeTypeEnum = Meevo.Model.FeeTypeEnum;
    import BillingTypeEnum = Meevo.Model.BillingTypeEnum;
    import AutoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;

    export class MembershipValidationController {

        private readonly notSetItem: string[] = [];

        // there should be only one primary membershipMemberSettings but who knows...
        private get _membershipMemberSettings(): IMembershipMemberSettings[] {
            return this._model.membershipMemberSettings.filter(settings => settings.memberType === MemberTypeEnum.Primary);
        }

        private get _recurringFeeVisible(): boolean {
            const { billingTypeEnum, membershipLength } = this._model;

            return billingTypeEnum !== BillingTypeEnum.PaidInFull && membershipLength !== 1;
        }

        private get _renewalFeeVisible(): boolean {
            const { autoRenewTypeEnum } = this._model;

            return [
                AutoRenewTypeEnum.Monthly,
                AutoRenewTypeEnum.PaidInFull,
                AutoRenewTypeEnum.Both,
            ].indexOf(autoRenewTypeEnum) !== -1;
        }

        constructor(private _model: Membership,
                    private $translate: ng.translate.ITranslateService) {
        }

        listItemNames(): string[] {
            this.notSetItem.length = 0;

            this._validateMethod(this._enrollmentFeeValid(), 'LABEL_ENROLLMENT_FEE');
            this._validateMethod(this._enrollmentPackageValid(), 'LABEL_ENROLLMENT_PACKAGE');
            this._validateMethod(this._recurringFeeValid(), 'LABEL_RECURRING_FEE');
            this._validateMethod(this._recurringPackageValid(), 'LABEL_RECURRING_PACKAGE');
            this._validateMethod(this._renewalFeeValid(), 'LABEL_RENEWAL_FEE');
            this._validateMethod(this._benefitTemplateValid(), 'LABEL_MEMBER_BENEFIT_TEMPLATE');

            return this.notSetItem;
        }

        listItemNamesCombined(): string {
            if (this.notSetItem.length === 0) return '';

            return `<li>${this.notSetItem.join('</li><li>')}</li>`
        }

        private _validateMethod(valid: boolean, message: string) {
            if (!valid) {
                this.notSetItem.push(this.$translate.instant(message));
            }
        }

        private _enrollmentFeeValid(): boolean {
            return this._membershipMemberSettings.some(({ enrollmentFee }) => !!enrollmentFee);
        }

        private _enrollmentPackageValid(): boolean {
            return this._packageTypeValid(FeeTypeEnum.Enrollment);
        }

        private _recurringFeeValid(): boolean {
            if (this._recurringFeeVisible) {
                return this._membershipMemberSettings.some(({ recurringFee }) => !!recurringFee);
            }

            return true;
        }

        private _recurringPackageValid(): boolean {
            if (this._recurringFeeVisible) {
                return this._packageTypeValid(FeeTypeEnum.Recurring);
            }

            return true;
        }

        private _renewalFeeValid(): boolean {
            if (this._renewalFeeVisible)
                return this._membershipMemberSettings.some(({ monthlyRenewalFee }) => !!monthlyRenewalFee);

            return true;
        }

        private _benefitTemplateValid(): boolean {
            return this._membershipMemberSettings.some(({ membershipBenefitTemplateId }) => !!membershipBenefitTemplateId);
        }

        private _packageTypeValid(_feeType: FeeTypeEnum) {
            return this._model.membershipPackageSettings.some(({ feeType }) => feeType === _feeType);
        }
    }
}
